import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSupercutField from '../../../../../../types/super-cut-field'
import AutoCropField from '../../../../../form-fields/super-cut/auto-crop'
import { CreationCaptureInfoContext } from '../manager'

const AutoCrop = styled(AutoCropField)`
    grid-column: span 1;
`

type Props = {
    className?: string
    field: CreationToolSupercutField
}

const CreationCaptureAutoCropField = ({ field }: Props) => {
    const { autoCrop, setAutoCrop } = useContext(CreationCaptureInfoContext)

    return (
        <AutoCrop
            {...{
                field,
                autoCrop,
                setAutoCrop,
            }}
        />
    )
}

export default CreationCaptureAutoCropField
